import React from 'react';
import ReactDOM from 'react-dom/client';
// import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './style/custom.css';
import './fonts/fonts.css';
import reportWebVitals from './reportWebVitals';
import AppRouter from "./AppRouter";
import { captureAdAttribution } from "./util/adAttribution";

/**
 * =========================
 * 광고 유입(adSrc) & 세션 처리
 * =========================
 * 규칙
 * 1. media/utm_source가 있으면 last-click으로 덮어쓴다. 없고 레거시 ad_src가 있으면
 *    sessionStorage가 비어있을 때만 저장한다(기존 동작 유지). 그래도 비어있으면 GENERAL 기본값.
 * 2. sessionId가 없으면 신규 방문으로 판단하여 생성
 * 3. React 렌더 이전에 실행 (Header보다 빠름)
 */
captureAdAttribution(window.location.search);

// UUID 생성 헬퍼 함수 (Secure Context가 아닐 경우 대비)
function generateUUID() {
    try {
        return crypto.randomUUID();
    } catch (e) {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            var v = c === 'x' ? r : ((r & 0x3) | 0x8);
            return v.toString(16);
        });
    }
}

// 2. sessionId 없으면 신규 세션 생성
if (!window.sessionStorage.getItem('sessionId')) {
    window.sessionStorage.setItem('sessionId', generateUUID());
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppRouter />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
